import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { TextLink } from 'secondstep-components'
import AdminHairline from 'components/admin/Hairline'

export const ChartsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  margin: 1rem 0 1.875rem;

  ${themeGet('breakpoints.medium')} {
    flex-direction: column;
    align-items: center;
    gap: 1.25rem;
    margin-bottom: 3.125rem;
  }
`

export const LessonCompletionLink = styled(TextLink)`
  align-self: flex-end;

  &:hover {
    cursor: pointer;
    text-decoration: none;
  }
`

export const SiteViewWrapper = styled.div.attrs(props => ({
  border: props.isSingleSite ? `2px solid black` : 'none',
  borderColor: props.isSingleSite ? themeGet('colors.paleGray')(props) : 'none',
}))`
  display: flex;
  flex-direction: column;
  border: ${({ border }) => border};
  border-color: ${({ borderColor }) => borderColor};
  border-radius: 0.625rem;
  padding: 1.5625rem 1.125rem 0.625rem;
`

export const StyledAdminHairline = styled(AdminHairline)`
  display: none;
  margin: 1.25rem 0 0.4375rem;
  width: 90%;

  ${themeGet('breakpoints.medium')} {
    display: block;
  }
`
